import React, { useState, useCallback, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import CommonComponentForQuestionsAndOption from '../Common/FeedbackGridRowForAlumni';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/css/styles.css';
import '../../assets/css/login.css';
var Modal = require('react-bootstrap-modal');
const axios = require('axios').default;
var config = require('../../config/config.json');

export default function AlumniFeedback(props) {
  document.title = props.title
  const navigate = useNavigate();
  let gridCount = 0;
  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userAlumniDetailsLog'));
  const [modelPopupStatus, setModelPopupStatus] = useState(false);
  const [componentLodignState, setComponentLodignState] = useState(false);
  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
  const [allQuestionsArray, setQuestionsArray] = useState([]);
  const [allAlumniAnswersArray, setAlumniAnswersArray] = useState([]);
  const [curriculumRequiresImprovement, setCurriculumRequiresImprovement] = useState('No');
  const [curriculumRequiresImprovementUG, setCurriculumRequiresImprovementUG] = useState('');
  const [curriculumRequiresImprovementPG, setCurriculumRequiresImprovementPG] = useState('');


  useEffect(() => {
    getAllQuestions();
  }, []);


  function onSubmitAlumniFeedbackClick() {

    let getQuestionsID = [];
    allQuestionsArray.map(function (questions, index) {
      if (questions.mafq_question_for_objective_or_descriptive == '0' && questions.mafq_appear_other_textbox == '0') {
        getQuestionsID.push(questions.mafq_auto_id)
      }
    })

    let getAnswerArrayWithoutDiscriptiveCount = 0;
    allAlumniAnswersArray.map((questions, index) => {
      if (questions.answer != "" && questions.description == "") {
        getAnswerArrayWithoutDiscriptiveCount += 1;
      }
    })

    if (getAnswerArrayWithoutDiscriptiveCount == getQuestionsID.length) {
      let validBit = true;
      let Obj = {};
      if (curriculumRequiresImprovement == "Yes") {
        if (curriculumRequiresImprovementUG != "" || curriculumRequiresImprovementPG != "") {
          validBit = true;
          let checkNewPushBit = true;
          let finalDescription = "UG: " + curriculumRequiresImprovementUG + " || " + "PG: " + curriculumRequiresImprovementPG
          Obj = {
            question_id: "73",
            answer: curriculumRequiresImprovement,
            description: finalDescription
          }
          allAlumniAnswersArray.find((o, i) => {
            if (o.question_id === "73") {
              allAlumniAnswersArray[i] = Obj;
              checkNewPushBit = false;
            }
          });
          if (checkNewPushBit) {
            allAlumniAnswersArray.push(Obj)
          }
          setAlumniAnswersArray(allAlumniAnswersArray);
        } else {
          validBit = false;
          toast.error("Please suggest how the curriculum can be strengthened for UG Level & PG Level");
        }
      } else {
        validBit = true;
        let checkNewPushBit = true;
        Obj = {
          question_id: "73",
          answer: curriculumRequiresImprovement,
          description: "No"
        }

        allAlumniAnswersArray.find((o, i) => {
          if (o.question_id === "73") {
            allAlumniAnswersArray[i] = Obj;
            checkNewPushBit = false;
          }
        });
        if (checkNewPushBit) {
          allAlumniAnswersArray.push(Obj)
        }
        setAlumniAnswersArray(allAlumniAnswersArray);
      }

      if (validBit) {
        axios.post(config.API_URL + 'submitAlumniFeedback', {
          ragisterUserId: userLoginDetails.alr_auto_id,
          answersArray: allAlumniAnswersArray
        }, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        }).then(function (response) {
          if (response.data.status.status == 1) {
            toast.success(response.data.status.message);
            // setModelPopupStatus(true);
            localStorage.removeItem("userAlumniDetailsLog");
            localStorage.removeItem("isAuthenticated");
            localStorage.clear();
            navigate('/ThankYou');
          }
        }).catch(function (error) {
          toast.error(error);
        });
      }

    } else {
      getQuestionsID.map((questions, index) => {
        let checkValidation = allAlumniAnswersArray.find(o => o.question_id === questions);
        if (!checkValidation) {
          var element = document.getElementById("studentInfra" + questions);
          element.classList.add("error");
        }
      });
      toast.error("All questions are compulsory.");
    }
  }

  function getAllQuestions() {
    setComponentLodignState(true);
    axios.post(config.API_URL + 'getAlumniFeedbackQuestion', {
      userId: userLoginDetails.LoginUserId
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setQuestionsArray(response.data.data);
        } else {
          setQuestionsArray([]);
        }
        setComponentLodignState(false);
      }
    }).catch(function (error) {
      toast(error);
      setComponentLodignState(false);
    });
  }


  const onItemClick = useCallback(event => {

    let Obj = {};
    if (event.target.getAttribute('q_type') !== "Descriptive") {
      Obj = {
        question_id: event.target.getAttribute('questionid'),
        answer: event.target.getAttribute('questionanswer'),
        description: ""
      }
    } else {
      Obj = {
        question_id: event.target.getAttribute('questionid'),
        answer: "",
        description: event.target.value
      }
    }

    if (allAlumniAnswersArray.length == 0) {
      allAlumniAnswersArray.push(Obj)
      setAlumniAnswersArray(allAlumniAnswersArray);
    } else {
      let checkNewPushBit = true;
      allAlumniAnswersArray.find((o, i) => {
        if (o.question_id === event.target.getAttribute('questionid')) {
          allAlumniAnswersArray[i] = Obj;
          checkNewPushBit = false;
        }
      });
      if (checkNewPushBit) {
        allAlumniAnswersArray.push(Obj)
      }
      setAlumniAnswersArray(allAlumniAnswersArray);
    }
    var element = document.getElementById("studentInfra" + event.target.getAttribute('questionid'));
    element.classList.remove("error");

    // console.log("allAlumniAnswersArray", allAlumniAnswersArray);
    // var target = event.target;
    // var parent = target.parentElement.parentElement;//parent of "target"
  }, [allQuestionsArray]);

  function clickOnLogOut() {
    localStorage.removeItem("userAlumniDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/Alumni');
  }

  let saveAndClose = () => {
    setModelPopupStatus(false);
    navigate('/AlumniDashboard');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;

  return (

    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userLoginDetails.userName}&nbsp;</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Alumni Feedback</div>
          </div>
          </div>
        </section>

        {componentLodignState == true ?
          <div class="loader-bg">
            <h3>Please Wait...</h3>
            <div class="loader">
              <span></span>
            </div>
          </div>
          :
          <section className='section-survey section-surveyStudentInfrastructure'>
            <div className="row">
              <div className="col-md-12">
                <div className='info info-white'>Fields marked with <em>*</em> are mandatory</div>
                <div className='questionnnaire-wrapper'>
                  <div className='grid-row row-header sticky'>
                    <div className='column col-srno'>#</div>
                    <div className='column col-question'><div className='column-content'> &nbsp; </div></div>
                    <div className='column col-grade'>Strongly Agree</div>
                    <div className='column col-grade'>Agree</div>
                    <div className='column col-grade'>Neutral</div>
                    <div className='column col-grade'>Disagree</div>
                    <div className='column col-grade'>Strongly Disagree</div>
                  </div>
                  {
                    allQuestionsArray.length >= 1 ?
                      allQuestionsArray.map((questions, index) => (
                        (questions.mafq_question_for_objective_or_descriptive == '0' ?
                          questions.mafq_appear_other_textbox == '0' ?
                            <CommonComponentForQuestionsAndOption term={questions} onItemClick={onItemClick} srNo={gridCount = gridCount + 1} />
                            : null
                          : null
                        )
                      ))
                      : null
                  }

                  {
                    allQuestionsArray.length >= 1 ?
                      allQuestionsArray.map((questions, index) => (
                        questions.mafq_question_for_objective_or_descriptive == '1' ?
                          <div className='grid-row grid-row-seperate' id={'studentInfra' + questions.mafq_auto_id}>
                            <div className='column col-srno'>{gridCount = gridCount + 1}</div>
                            <div className='column col-fullWidthQuestion'><div className='column-content'>{questions.mafq_question} <br />
                              <textarea id="textarea1" className='textarea' rows="2" placeholder="Remarks, if any" onChange={onItemClick} q_type="Descriptive" questionid={questions.mafq_auto_id} style={{ padding: '10px', resize: 'none' }}></textarea>
                            </div></div>
                          </div>
                          : null
                      ))
                      : null
                  }

                  <div className='grid-row grid-row-seperate'>
                    <div className='column col-srno'>{allQuestionsArray.length + 1}.</div>
                    <div className='column col-fullWidthQuestion'>
                      <div className='column-content  col-md-12'>Do you think that the curriculum requires improvement?
                        <select className='form-control' value={curriculumRequiresImprovement} style={{ width: 'auto', display: 'initial', marginLeft: '13px' }} onChange={(e) => { setCurriculumRequiresImprovement(e.target.value) }}>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>
                      {curriculumRequiresImprovement == "Yes" ?
                        <div className='curriculumChange col-md-12'>
                          <hr />
                          If yes, Suggest how the curriculum can be strengthened  <br />
                          a) UG Level<textarea id="textarea1" placeholder="Please suggest how the curriculum can be strengthened for UG Level" className='textarea' rows="2" style={{ padding: '10px', resize: 'none' }} onChange={(e) => { setCurriculumRequiresImprovementUG(e.target.value) }}></textarea><br />
                          b) PG Level<textarea id="textarea1" placeholder="Please suggest how the curriculum can be strengthened for PG Level" className='textarea' rows="2" style={{ padding: '10px', resize: 'none' }} onChange={(e) => { setCurriculumRequiresImprovementPG(e.target.value) }}></textarea>
                        </div>
                        : null}
                    </div>
                  </div>

                </div>
              </div>
              <div className='col-md-12'>
                <button type="button" className="btn btn-primary btn-submitForm btn-block" onClick={onSubmitAlumniFeedbackClick}>Submit</button>
              </div>
            </div>
          </section>
        }
        <section className='section-footer'>
          <div className='row'>
            <div className='footer'>
              <div className='col-md-6 col-sm-6' >{config.collegeName}, Feedback System {config.version}</div>
              <div className='col-md-6 col-sm-6 text-poweredBy'>{config.PoweredBy}</div>
            </div>
          </div>
        </section>
      </div>
      <ToastContainer />
      <Modal
        show={modelPopupStatus}
        backdrop="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Body>
          <div className="font-robo">
            <div className="">
              <div className="card card-1 " style={{ boxShadow: 'none' }}>
                {/* <div className="logo-holder">
                  <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
                  <div className='feedback-title' >Feedback System</div>
                </div> */}
                <div className="card-body card-thankyou" style={{ padding: '5px 5px', textAlign: 'center' }}>
                  <center>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                      <circle className="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                      <polyline className="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                    </svg>
                  </center>
                  <div className='message-submitThankyou'>
                    <h3>Feedback submitted successfully.<br />
                      Thank you for your valuable time.</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <center>
            <button className='btn btn-primary btn-submitForm' style={{ display: 'block' }} onClick={saveAndClose}>
              Back to Main Page
            </button>
          </center>
        </Modal.Footer>
      </Modal>
    </div>
  )
}